import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLolInhibitor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.00001 0C2.23867 0 0 2.23867 0 5C0 7.76133 2.23867 10 5.00001 10C7.76134 10 10 7.76133 10 5C10 2.23867 7.75903 0 5.00001 0ZM5.00001 8.26781C3.19381 8.26781 1.7322 6.80389 1.7322 5C1.7322 3.1938 3.19612 1.73219 5.00001 1.73219C6.8062 1.73219 8.26781 3.19611 8.26781 5C8.26781 6.8062 6.80389 8.26781 5.00001 8.26781Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.2932 4.94989L4.99889 2.65558L2.70458 4.94989L4.99889 7.24421L7.2932 4.94989Z",
		fill: "currentColor"
	})]
});
export default SvgLolInhibitor;
